// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import theme from './styles/theme';

// Page components
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import CollaborationLayer from './features/collaboration/CollaborationLayer';
import OperationalLayer from './features/operational/OperationalLayer';
import TuitionLayer from './features/tuition/TuitionLayer'; // Import the new TuitionLayer
import ProfessionalDevelopment from './features/professional/ProfessionalDevelopment';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import PostView from './pages/PostView';
import ResourcesLayer from './pages/ResourcesLayer';
import EventsPage from './pages/EventsPage';
import EventDetailsPage from './pages/EventDetailsPage';
import ConnectionsPage from './features/collaboration/components/ConnectionsPage';
import GroupsPage from './pages/GroupsPage';
import GroupDetailPage from './pages/GroupDetailPage';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  
  if (loading) return <div>Loading...</div>;
  
  if (!currentUser) return <Navigate to="/login" replace />;
  
  return children;
};

const PostRedirect = () => {
  const { postId } = useParams();
  return <Navigate to={`/post/${postId}`} replace />;
};

const App = () => {
  return (
    <AuthProvider>
      <NotificationsProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            <Route path="/post/:postId" element={<PostView />} />
            <Route path="/collaboration/post/:postId" element={<PostRedirect />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/collaboration" replace />} />
              <Route path="collaboration" element={<CollaborationLayer />} />
              <Route path="resources" element={<ResourcesLayer />} />
              <Route path="operational" element={<OperationalLayer />} />
              <Route path="tuition" element={<TuitionLayer />} /> 
              <Route path="professional" element={<ProfessionalDevelopment />} />
              <Route path="profile" element={<Profile />} />
              <Route path="events" element={<EventsPage />} />
              <Route path="events/:eventId" element={<EventDetailsPage />} />
              <Route path="connections" element={<ConnectionsPage />} />
              <Route path="connections/requests" element={<ConnectionsPage initialTab={1} />} />
              <Route path="groups" element={<GroupsPage />} />
              <Route path="groups/:groupId" element={<GroupDetailPage />} />

            </Route>
            
            <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </NotificationsProvider>
    </AuthProvider>
  );
};

export default App;
